import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { getAuthLocationInfo } from '../utils/helper';
import { useState } from 'react';
import { AuthSpiralIcon, WatermarkIcon, WhiteLogo } from '../components/icons';

const AuthenticationLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const [showConfirmation, setShowConfirmation] = useState(false);

    const cleanedPathname = Object.values(params).reduce(
        (path, param) => path?.replace(`/${param}`, ''),
        location.pathname
    );

    const { title, info, infoText } = getAuthLocationInfo(
        cleanedPathname ?? '',
        showConfirmation
    );

    return (
        <div className='min-h-screen max-h-full bg-appcolorprimary pt-4 px-[1.7rem] lg:px-[9.1rem] relative'>
            <div className='flex justify-between'>
                <div
                    onClick={() => {
                        navigate('/login');
                    }}
                    className='cursor-pointer'
                >
                    <WhiteLogo />
                </div>

                <p>
                    <span className='cursor-pointer text-appcolorwhite text-[13px] leading-[23px]'>
                        Learn More
                    </span>
                </p>
            </div>

            <div className='absolute right-[10rem] top-[3rem] hidden lg:block'>
                <WatermarkIcon />
            </div>

            <div
                className={`flex justify-start w-full my-auto mt-[5.0rem] lg:mt-[5rem]`}
            >
                <div className='lg:w-[90%] flex items-center flex-col lg:flex-row'>
                    <div className='lg:w-[50%] w-full'>
                        <div className='lg:w-[70%] mb-8 lg:mb-0 '>
                            <div className='flex mb-[1.3rem] items-center'>
                                <div className='mr-4'>
                                    <AuthSpiralIcon />
                                </div>

                                <p className='text-appcolorwhite tracking-[0.4rem] text-[13px] leading-[23px]'>
                                    {title}
                                </p>
                            </div>

                            <h1 className='font-light text-appcolorwhite text-[40px] text-left lg:text-[59px] leading-[93.5%] mb-[1.9rem]'>
                                {info}
                            </h1>

                            {infoText !== undefined && (
                                <p className='text-lg font-light text-appcolorwhite text-left'>
                                    {infoText}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className='relative lg:w-[50%] w-full'>
                        <Outlet
                            context={{ showConfirmation, setShowConfirmation }}
                        />
                    </div>
                </div>
            </div>

            <div className='left-0 mb-8 lg:absolute bottom-8 lg:mb-0'>
                <p className='text-sm font-light text-appcolorwhite leading-[23px] lg:pl-[9.1rem] mt-4 lg:mt-0 text-left'>
                    <span>©FrontEdge {new Date().getFullYear()}</span>
                </p>
            </div>
        </div>
    );
};

export default AuthenticationLayout;
